export default __webpack_public_path__ + "static/media/ringer.0c78daeb.mp3";